import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import mapboxgl from "mapbox-gl";
import { devices } from "../../mock/data";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DevicesIcon from "@mui/icons-material/Devices";
import { useMaterialUIController } from "context";

mapboxgl.accessToken =
  "pk.eyJ1IjoibGVvbnRvbWVyIiwiYSI6ImNtNTVjeTdwcTJ3em4yanNkeHg3eDNhaW0ifQ.3Tg0RL9HhK4yQRzVpMMB1Q";

function DeviceDetails() {
  const { serialNumber } = useParams();
  const [lngLat, setLngLat] = useState(null);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const textColor = darkMode ? "#fff" : "#000"; // Set text color based on dark mode

  const findDeviceBySerialNumber = (devices, serialNumber) => {
    return devices.find((device) => device.serialNumber === serialNumber) || null;
  };
  const device = findDeviceBySerialNumber(devices, serialNumber);

  useEffect(() => {
    if (device) {
      const fetchCoordinates = async () => {
        try {
          const response = await fetch(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
              device.address
            )}.json?access_token=${mapboxgl.accessToken}`
          );
          const data = await response.json();
          if (data.features && data.features.length > 0) {
            const [longitude, latitude] = data.features[0].center;
            setLngLat({ longitude, latitude });
          }
        } catch (error) {
          console.error("Geocoding error:", error);
        }
      };
      fetchCoordinates();
    }
  }, [device]);

  useEffect(() => {
    if (!lngLat || !mapContainerRef.current) return;

    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });

      new mapboxgl.Marker().setLngLat([lngLat.longitude, lngLat.latitude]).addTo(mapRef.current);
    } else {
      mapRef.current.flyTo({
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });
    }
  }, [lngLat]);

  if (!device) {
    return <div>Device not found.</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: "20px" }}>
        <Typography variant="h4" gutterBottom style={{ color: textColor }}>
          Device Details
        </Typography>
        <Grid container spacing={3}>
          {/* Serial Number */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <DevicesIcon style={{ marginRight: 8 }} /> Serial Number
                </Typography>
                <Typography style={{ color: textColor }}>{device.serialNumber}</Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Name */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <DevicesIcon style={{ marginRight: 8 }} /> Name
                </Typography>
                <Typography style={{ color: textColor }}>{device.name}</Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Address */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <LocationOnIcon style={{ marginRight: 8 }} /> Address
                </Typography>
                <Typography style={{ color: textColor }}>{device.address}</Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Status */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <DevicesIcon style={{ marginRight: 8 }} /> Status
                </Typography>
                <Typography style={{ color: textColor }}>{device.status}</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Map Section */}
        <div ref={mapContainerRef} style={{ width: "100%", height: "400px", marginTop: "20px" }} />
      </div>
    </DashboardLayout>
  );
}

export default DeviceDetails;
